/**
 * Whether the review dialog may be saved, and which sequence is blocking it.
 *
 * Validity is THREE-state, not boolean. `null` means the messages have not
 * loaded yet, which is different from invalid: the emptiness check reads an
 * absent draft as "empty", so treating unknown as invalid told every founder to
 * "fix" a sequence they had not been shown, for as long as generation took.
 */
export type SequenceValidity = boolean | null

/** Approval needs a definite yes from every active sequence. Unknown is not yes. */
export function canApproveReview(input: {
  investor: SequenceValidity
  portfolio: SequenceValidity
  portfolioActive: boolean
}): boolean {
  const { investor, portfolio, portfolioActive } = input
  return investor === true && (!portfolioActive || portfolio === true)
}

/**
 * The sequence to name in the "fix this to save" message, or null for none.
 *
 * Only an explicit `false` blocks. Save gates on BOTH tabs when portfolio is
 * active, so the founder has to be told which one to open — otherwise they edit
 * the visible sequence and the button stays dead.
 */
export function blockingReviewSequence(input: {
  investor: SequenceValidity
  portfolio: SequenceValidity
  portfolioActive: boolean
}): 'Investors' | 'Portfolio founders' | null {
  const { investor, portfolio, portfolioActive } = input
  if (investor === false) return 'Investors'
  if (portfolioActive && portfolio === false) return 'Portfolio founders'
  return null
}
